document.documentElement.classList.remove('no-js');
document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;
  const option = select.options[select.selectedIndex];
  const form = select.closest('form');
  const idInput = form && form.querySelector('input[name="id"]');
  if (idInput && option.value) idInput.value = option.value;
});

// v2.2 product image lightbox
(() => {
  const lightbox = document.querySelector('[data-product-lightbox]');
  const gallery = document.querySelector('[data-product-gallery]');
  if (!lightbox || !gallery) return;

  const triggers = Array.from(gallery.querySelectorAll('[data-lightbox-trigger]'));
  const image = lightbox.querySelector('[data-lightbox-image]');
  const counter = lightbox.querySelector('[data-lightbox-counter]');
  const prev = lightbox.querySelector('[data-lightbox-prev]');
  const next = lightbox.querySelector('[data-lightbox-next]');
  const closeButtons = lightbox.querySelectorAll('[data-lightbox-close]');
  let currentIndex = 0;
  let lastFocused = null;

  const render = (index) => {
    if (!triggers.length) return;
    currentIndex = (index + triggers.length) % triggers.length;
    const trigger = triggers[currentIndex];
    image.src = trigger.dataset.imageSrc || '';
    image.alt = trigger.dataset.imageAlt || '';
    if (counter) counter.textContent = `${currentIndex + 1} / ${triggers.length}`;
  };

  const open = (index, trigger) => {
    lastFocused = trigger || document.activeElement;
    render(index);
    lightbox.hidden = false;
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.classList.add('lightbox-open');
    const close = lightbox.querySelector('.product-lightbox-close');
    if (close) close.focus();
  };

  const close = () => {
    lightbox.hidden = true;
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('lightbox-open');
    image.removeAttribute('src');
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  };

  triggers.forEach((trigger, index) => {
    trigger.addEventListener('click', () => open(index, trigger));
  });
  closeButtons.forEach((button) => button.addEventListener('click', close));
  if (prev) prev.addEventListener('click', () => render(currentIndex - 1));
  if (next) next.addEventListener('click', () => render(currentIndex + 1));

  document.addEventListener('keydown', (event) => {
    if (lightbox.hidden) return;
    if (event.key === 'Escape') close();
    if (event.key === 'ArrowLeft') render(currentIndex - 1);
    if (event.key === 'ArrowRight') render(currentIndex + 1);
  });
})();


// v2.4 catalog team tag filter
(() => {
  const tools = document.querySelector('[data-catalog-tools]');
  const select = document.querySelector('[data-team-filter]');
  if (!tools || !select) return;

  const base = tools.dataset.collectionUrl || '/collections/all';
  const pathParts = window.location.pathname.split('/').filter(Boolean);
  const tagSegment = pathParts.length >= 3 && pathParts[0] === 'collections' ? decodeURIComponent(pathParts.slice(2).join('/')) : '';

  const slugify = (value) => value.toLowerCase()
    .trim()
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  if (tagSegment) {
    const current = tagSegment.toLowerCase();
    Array.from(select.options).forEach((option) => {
      if (option.value && slugify(option.value) === current) option.selected = true;
    });
  }

  select.addEventListener('change', () => {
    const value = select.value;
    const sort = new URLSearchParams(window.location.search).get('sort_by');
    let destination = base;
    if (value) destination = `${base}/${slugify(value)}`;
    if (sort) destination += `?sort_by=${encodeURIComponent(sort)}`;
    window.location.href = destination;
  });
})();
